import { useEffect } from 'react';

const SELECTOR = '.str-chat__textarea textarea';
const DEFAULT_HEIGHT = '40px';

export default function useSmartTextareaResize() {
	useEffect(() => {
		let textarea: HTMLTextAreaElement | null = null;

		const resize = () => {
			if (!textarea) return;
			if (textarea.value === '') {
				textarea.style.height = DEFAULT_HEIGHT;
			} else {
				textarea.style.height = 'auto';
				textarea.style.height = `${textarea.scrollHeight}px`;
			}
		};

		const bind = () => {
			const el = document.querySelector<HTMLTextAreaElement>(SELECTOR);
			if (el && el !== textarea) {
				textarea?.removeEventListener('input', resize);
				textarea = el;
				textarea.style.height = DEFAULT_HEIGHT;
				textarea.addEventListener('input', resize);
				resize();
			}
		};

		const observer = new MutationObserver(bind);
		observer.observe(document.body, {
			subtree: true,
			childList: true,
		});

		const interval = setInterval(() => {
			if (!textarea || !document.body.contains(textarea)) {
				bind();
			}
			resize();
		}, 300);

		return () => {
			clearInterval(interval);
			observer.disconnect();
			textarea?.removeEventListener('input', resize);
		};
	}, []);
}
